import React from 'react'
import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { ENewFilterRangeDesktop } from './static-props'
import { ariaLabel } from '../../utils/form-utilities'

const YearMin = withFilterContext(FilterName.min_year_manufactured, SearchFiltersDropdown, {
    title: ENewFilterRangeDesktop.MIN,
    ariaLabel: ariaLabel.year.min,
})
const YearMax = withFilterContext(FilterName.max_year_manufactured, SearchFiltersDropdown, {
    title: ENewFilterRangeDesktop.MAX,
    ariaLabel: ariaLabel.year.max,
})

export const YearMinAndMax = withFacetContext(FacetName.year_manufactured, () => (
    <>
        <YearMin title={ENewFilterRangeDesktop.MIN} />
        <YearMax title={ENewFilterRangeDesktop.MAX} />
    </>
))
